import Component from 'core/Component';
import Button from 'core/component/Button';
import prop from 'core/helper/prop';

class LoginContainer extends Component {
  oninit() {
    this.username = prop('');
    this.password = prop('');

    this.checkUser = () => {
      if (this.isValidUsername(this.username()) || (this.isValidUsername(this.password())))
        alert("Username/Password are not allowed to have space or symbols!");
      else if (!_.isEmpty(this.password()) && !_.isEmpty(this.username())) {
        return m.request({
          url: 'findUser', method: 'POST', data: {
            username: this.username,
            password: this.password,
          },
        })
          .then((result) => {
            if (!_.isEmpty(result.result)) //success should return as result : 'ok'
            {
              return m.request({
                url: 'login', method: 'POST', data: {
                  username: this.username,
                  password: this.password,
                },
                deserialize: (data) => data
              })
                .then((result) => {
                  if (!_.isEmpty(result))
                    //return window.location.href = "/"; //original setting - leads to IndexPage
                  return window.location.href = "/#/address/search";
                  else
                    return alert("*User account might be in used, please logout from another browser before login again");
                })
                .catch(() => {
                  alert("*User account might be in used, please logout from another browser before login again");
                })
            }
            else {
              return alert("Error! " + result.loginMessage);
            }
          })
          .catch(() => {
            alert('System Login error, please try again later');
          })
      }
      else {
        alert("Please key in your username and password to retrieve the password");
      }

    };
  }

  view() {
    return m('div', [
      this.loginHeader(),
      m('a.hiddenanchor#signup'),
      m('a.hiddenanchor#signin'),
      m('.login_wrapper', {style: 'margin-top: 40px;'}, [
        m('.animate.from.login_form', this.loginContent())
      ])
    ]);
  }

  loginHeader() {
    return m('.login_header', { style: 'width: 100%; text-align: center; margin: 25px auto 0px; display: inline-block;' }, [
      m('div', {style: 'margin: auto; width: 60%;'}, [
        m('img', { src: 'mapit_icon.png', width: '105px', height: '80px' }),
        m('p', { style: 'font-size: 40px; font-weight: bold;' }, 'MapIT Map Portal'),
      ]),
    ])
  }

  loginContent() {
    const ctrl = this;
    return m('section.login_content', [
      m('form', { method: 'POST', action: window.location }, [
        m('h1', {style: 'letter-spacing: 5px;'}, 'LOGIN'),
        m('div', {style: 'text-align: center;'}, [
          m('p', {style: 'font-weight: bold; font-size: 16px; color: #F36422; margin: 0px;'}, 'USERNAME'),
          m('input.form-control', {
            type: 'text', name: 'username', required: true, style: 'text-align: center;',
            onchange: m.withAttr('value', ctrl.username), value: ctrl.username()
          })
        ]),
        m('div', {
          style: 'text-align: center;',
          config: (el, isInitialized, context) => {
            el.addEventListener('keyup', (event) => {
              if(!isInitialized) {
                if (event.keyCode == 13) {
                  return this.checkUser();
                }
              }
            })
          }
        }, [
          m('p', {style: 'font-weight: bold; font-size: 16px; color: #F36422; margin: 0px;'}, 'PASSWORD'),
          m('input.form-control', {
            type: 'password', name: 'password', required: true, style: 'text-align: center;',
            onchange: m.withAttr('value', ctrl.password), value: ctrl.password()
          })
        ]),
        m('div', {style: 'width: 100%; display: inline-block; text-align: center;'}, [
          m('button', {
            className: 'btn btn-default submit', type: 'submit', 
            style: 'margin: 0px; float: none; width: 120px; height: 40px;'}, 'LOG IN'),
        ]),
        m('div', {style: 'width: 100%; display: inline-block; text-align: center; margin-top: 15px;'}, [
          m('a', {
            className: 'reset_pass', href: '/forgotPassword',
            style: 'margin: 0px; float: none; font-weight: bold;'}, 'Lost your password?'),
        ]),
        m('.clearfix'),
        m('.separator', this.loginFooter()),
      ]),
    ]);
  }

  loginFooter() {
    return m('div', [
      m('p', {style: 'color: #F36422; font-weight: bold;'}, '©2017 Gentelella by Colorlib'),
      m('p', {
        style: 'cursor: pointer;',
        onclick: () => { alert('Redirect to T&C page'); },
      },'Terms & Conditions'),
      m('p', {
        style: 'cursor: pointer;',
        onclick: () => { alert('Redirect to Privacy Policy page'); },
      },'Privacy Policy')
      // m('p', [
      //   '©2017 Eagle Eye by Mapit', m('br'),
      //   m('small', '©2017 Gentelella by Colorlib')
      // ]),
    ]);
  }
}

m.render(document.body, [
  m('#content'),
]);
m.mount(document.getElementById('content'), LoginContainer);